export default __webpack_public_path__ + "static/media/cow_skull_charcoal.cb5eea65.jpg";